import ListarCliente from '@/features/client/components/liste-clientes-form'
import { useTenantContext } from '@/context/tenant'
import { useAccessToken, useLoadPermissions } from '@/features/auth/state/auth'
import { useEffect } from 'react'

export function ClientesListPage() {
  const token = useAccessToken()
  const { currentTenant, selectedTenant } = useTenantContext()
  const tenant = selectedTenant || currentTenant
  const idTenant = tenant?.id
  const loadPermissions = useLoadPermissions()
  // const lastTenantLoadedRef = useRef<string | null>(null)

  useEffect(() => {
    if (!idTenant || !token) return
    // if (lastTenantLoadedRef.current === idTenant) return
    // lastTenantLoadedRef.current = idTenant
    loadPermissions(token)
  }, [idTenant, token, loadPermissions])

  return <ListarCliente id_tenant={idTenant} />
}
